import React from "react";
import Utils from "../../../Utils";
import classes from "./FeatureCard.module.css";

function FeatureCard({ title, bulletPoints, imageUrl, imageAlt, reverse = false }) {
  return (
    <article className={Utils.getClasses(reverse ? classes.reverse : "", classes.section)}>
      <div className={classes.content}>
        <h2 className={classes.title}>{title}</h2>
        <ul className={classes.bulletPoints}>
          {bulletPoints.map((point, index) => (
            <li key={index} className={classes.bulletPoint}>
              {point}
            </li>
          ))}
        </ul>
      </div>
      <div className={classes.imageWrapper}>
        <div className={classes.imageContainer}>
        <img  src={imageUrl} alt={imageAlt} width={200} height={200} className={classes.image} />
        </div>
      </div>
    </article>
  )
}

export default FeatureCard;